var map = {
	"./1.3.0": 6468,
	"./1.3.0/": 6468,
	"./1.3.0/CrossChainDispatcher": 88688,
	"./1.3.0/CrossChainDispatcher.json": 88688,
	"./1.3.0/DebtToken": 51783,
	"./1.3.0/DebtToken.json": 51783,
	"./1.3.0/DepositToken": 45500,
	"./1.3.0/DepositToken.json": 45500,
	"./1.3.0/FeeProvider": 35771,
	"./1.3.0/FeeProvider.json": 35771,
	"./1.3.0/MerkleV2Abi": 73235,
	"./1.3.0/MerkleV2Abi.json": 73235,
	"./1.3.0/Pool": 68458,
	"./1.3.0/Pool.json": 68458,
	"./1.3.0/PoolRegistry": 25537,
	"./1.3.0/PoolRegistry.json": 25537,
	"./1.3.0/Quoter": 62904,
	"./1.3.0/Quoter.json": 62904,
	"./1.3.0/RewardsDistributor": 86292,
	"./1.3.0/RewardsDistributor.json": 86292,
	"./1.3.0/Swapper": 36104,
	"./1.3.0/Swapper.json": 36104,
	"./1.3.0/SyntheticToken": 10660,
	"./1.3.0/SyntheticToken.json": 10660,
	"./1.3.0/index": 6468,
	"./1.3.0/index.js": 6468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20143;